import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function PlacedInServiceInfoContent() {
  return (
    <>
      <InfoPanelTitle>
        What does &quot;placed in service&quot; mean for a property?
      </InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          You mark your property &quot;placed in service&quot; when it is first
          prepared and available for you to rent.
        </p>
        <p>
          A property is considered &quot;placed in service&quot; when you have
          fully prepared it for rental use, for example, by advertising it for
          rent or making it ready for tenants to move in. Your property does not
          require having an actual tenant yet to count as placed in service.
        </p>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'Publication 527 (2024), Residential Rental Property',
              url: 'https://www.irs.gov/publications/p527',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
